import { render, staticRenderFns } from "./MemberResendEmailModal.vue?vue&type=template&id=e18f84fa&scoped=true&"
import script from "./MemberResendEmailModal.vue?vue&type=script&lang=js&"
export * from "./MemberResendEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./MemberResendEmailModal.vue?vue&type=style&index=0&id=e18f84fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18f84fa",
  null
  
)

export default component.exports